import * as React from 'react';
import { Selectors } from '@grandvisionhq/auth';
import { useSelector } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import { getServiceStore, shouldCreateAccount } from '../../selectors.js';
import { isShippingStepValid } from '../selectors.js';

const useShippingStepValidation = ()=>{
    var ref4, ref1, ref2, ref3;
    const checkoutSettings = useCheckoutSettings();
    const isServiceStoreEnabled = (ref4 = checkoutSettings.features) === null || ref4 === void 0 ? void 0 : ref4.isServiceStoreEnabled;
    const isCreateAccountRequired = Boolean(((ref1 = checkoutSettings.account) === null || ref1 === void 0 ? void 0 : ref1.implicitAccountCreation) || ((ref2 = checkoutSettings.account) === null || ref2 === void 0 ? void 0 : ref2.createAccountRequired));
    const isLoggedIn = useSelector(Selectors.isLoggedIn);
    const isShippingStepValidBoolean = useSelector(isShippingStepValid);
    const selectedServiceStore = useSelector(getServiceStore);
    const shouldCreateAccountBoolean = useSelector(shouldCreateAccount);
    const isStepShippingValid = React.useCallback(()=>{
        var ref;
        const haveValidServiceStore = !isServiceStoreEnabled || !!selectedServiceStore || isServiceStoreEnabled && Boolean((ref = checkoutSettings.serviceStore) === null || ref === void 0 ? void 0 : ref.isOptional);
        const haveValidAccount = isLoggedIn || !isCreateAccountRequired || shouldCreateAccountBoolean;
        return isShippingStepValidBoolean && haveValidServiceStore && haveValidAccount;
    }, [
        (ref3 = checkoutSettings.serviceStore) === null || ref3 === void 0 ? void 0 : ref3.isOptional,
        isCreateAccountRequired,
        isLoggedIn,
        isServiceStoreEnabled,
        isShippingStepValidBoolean,
        selectedServiceStore,
        shouldCreateAccountBoolean, 
    ]);
    return React.useMemo(()=>({
            isStepShippingValid
        })
    , [
        isStepShippingValid
    ]);
};

export { useShippingStepValidation };
//# sourceMappingURL=use-shipping-step-validation.js.map
